import Http from "@services/http";
import BaseApi from "@api/base.api";

export default class DocumentApi extends BaseApi {
    static get entity() {
        return "documents";
    }

    static async getByIds(params = {}) {
        return await Http.get("documents/bulk", params);
    }

    static async increment(id,params={}){
        return await Http.post('document/increment/'+id,params)
    }

}
